// @ vendor
import React, { useEffect } from 'react'

import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import './depositsRenovationInfoModal.scss'

import { OKButton } from 'components/commons/OKButton/OKButton';
import OKModal from 'components/commons/OKModal/OKModal'
import { OKSectionBox } from 'commonsComponents/OKSectionBox'
import { LoadingSection } from 'commonsComponents/loadingSection'
import { EmptyState } from 'commonsComponents/emptyState'

import { DepositRenovationInfo } from './depositRenovationInfo/depositRenovationInfo'

import actionDepositsCancel from 'actions/depositsRenovationCancel'
import {
    IDLE,
    FETCHING,
    FETCH_FAILED,
    FETCHED
} from 'constants/contactCenter/depositOrImpositionCancellationStatus'

import { recordLink } from 'utilities/tagging'
import {
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_TAG_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_READ_TAG_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CLOSE_TAG_EVENT,
    DEFERRAL_DEPOSIT_MODAL_CONDITIONS_FETCH_FAILED_TAG_EVENT
} from 'constants/tagging';
import { i18n } from 'core/i18n';

const WEB_POE_KEYS = {
    description: 'contractsView-contractsView_depositConditionDescription',
    title: 'contractsView-contractsView_depositConditionTitle',
    actionButton: 'contractsView-contractsView_depositConditionPrimaryButton',
    emptyState: 'contractsView-contractsView_depositConditionEmptyState'
}

const CONTACT_CENTER_POE_KEYS = {
    description: 'contractsView-contractsView_ccDepositConditionDescription',
    title: 'contractsView-contractsView_ccDepositConditionTitle',
    actionButton: 'contractsView-contractsView_ccDepositConditionPrimaryButton',
    emptyState: 'contractsView-contractsView_ccDepositConditionEmptyState'
}


export const DepositsRenovationInfoModal = ({
	isOpen,
    closeFunction,
    renovationCancel,
    immDepositsRenovationCancel,
    requestDepositRenovationConditions,
    immAccounts,
    immDeposit,
}) => {
    const { FormattedText, formatText } = i18n

    const poeKeys = __CONTACT_CENTER__
        ? CONTACT_CENTER_POE_KEYS
        : WEB_POE_KEYS

    const getDepositContract = () => {
        const depositContract = immDeposit.getIn(['contract', 'contractNumber'])
        return depositContract
    }

    useEffect(() => {
        if (isOpen) {
            recordLink(
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT,
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT,
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_TAG_EVENT
            )
            const depositContract = getDepositContract()
            requestDepositRenovationConditions(depositContract)
        }
	}, [isOpen])

    const handleClose = (fromButton = false) => {
        const tagEvent = fromButton 
            ? DEFERRAL_DEPOSIT_MODAL_CONDITIONS_READ_TAG_EVENT
            : DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CLOSE_TAG_EVENT

        recordLink(DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT, DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT, tagEvent)
        closeFunction()
    }

    const isLoading = () => {
        if (!isOpen) { return false }
        return immDepositsRenovationCancel.get('status') === FETCHING
    }

    const renderInformation = () => {
        const status = immDepositsRenovationCancel.get('status')

        if (!isOpen && status !== FETCHED) { return null }

        if (status === IDLE || isLoading()) {
            return (
                <OKSectionBox>
                    <LoadingSection />
                </OKSectionBox>
            )
        }

        if (status === FETCH_FAILED) {
            recordLink(
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_CATEGORY_EVENT,
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_ACTION_EVENT,
                DEFERRAL_DEPOSIT_MODAL_CONDITIONS_FETCH_FAILED_TAG_EVENT
            )
            return (
                <EmptyState
                    primaryText={formatText(poeKeys.emptyState)}
                    iconType="noitems-banking"
                />
            )
        }

        const renovations = immDepositsRenovationCancel.get('renovations')

        return renovations.map((renovation) => (
            <DepositRenovationInfo
                key={renovation.get('accountContract')}
                onRenovationCancel={renovationCancel}
                depositContractNumber={getDepositContract()}
                depositId={renovation.get('id')}
                immRenovation={renovation}
                immAccounts={immAccounts}
                immDeposit={immDeposit}
            />
        )).toJS()
    }
    
	const modalContent = () =>  (
    <div className="deposit-renovation-info__content">
        <p className="deposit-renovation-info__description">
            <FormattedText value={poeKeys.description} />
        </p>
        { renderInformation() }
    </div>
    )

	return (
    <OKModal
        onCloseCallback={handleClose}
        overlayClassName={"ok-modal-information"}
        content={modalContent()}
        size="regular"
        contentOverflow="auto"
        headerType="custom"
        headerContent={
            <h3 className="deposit-renovation-info__header">
                <FormattedText value={poeKeys.title} />
            </h3>
		}
        isOpen={isOpen}
        titleAlignment="center"
        contentFooter={
            <div className="deposit-renovation-info__footer">
                <OKButton onClick={() => handleClose(true)} disabled={isLoading()}>
                    <FormattedText value={poeKeys.actionButton} />
                </OKButton> 
            </div>
		}
	/>)
}

DepositsRenovationInfoModal.propTypes = {
    isOpen: PropTypes.bool,
    closeFunction: PropTypes.func,
    renovationCancel: PropTypes.func,
    immDepositsRenovationCancel: PropTypes.object,
    immDeposit: PropTypes.object,
    immAccounts: PropTypes.object,
    requestDepositRenovationConditions: PropTypes.func
};

module.exports.constructor = DepositsRenovationInfoModal;
module.exports.DepositsRenovationInfoModal = connect(
    state => ({
        immDepositsRenovationCancel: state.depositsRenovationCancel,
        immAccounts: state.accounts,
    }), {
        requestDepositRenovationConditions: actionDepositsCancel.requestDepositRenovationConditions
    }
)(DepositsRenovationInfoModal);
